import { getRequest, postRequest } from "./NetworkService";

export const getBillingService = async (
  endPoint: string
) => {
  let { data }: { data: any } = await getRequest(
    endPoint
  );
  return data;
};



export const UpdateSubscriptionService = async (
  endPoint: string,
  requestBody: {
    userId: number,
    amount: number
}
) => {
  let { data }: { data: any } = await postRequest(
    endPoint,
    requestBody
  );
  return data;
};
